import { AuxiliarMeta } from '~/layers/forms/models'

export type Address = Nullable<{
  line1: string
  line2: string
  postalCode: string
  country: AuxiliarMeta
  province: AuxiliarMeta
  municipality: AuxiliarMeta
  sector: AuxiliarMeta
}>

function load(model?: Partial<Address> | null): Address {
  return {
    line1: model?.line1 ?? null,
    line2: model?.line2 ?? null,
    postalCode: model?.postalCode ?? null,
    country: model?.country ?? AuxiliarMeta.load({ code: 'DO' }),
    province: model?.province ?? AuxiliarMeta.load(),
    municipality: model?.municipality ?? AuxiliarMeta.load(),
    sector: model?.sector ?? AuxiliarMeta.load(),
  }
}

function getFullAddress(address: Address) {
  return {
    area: [address.province?.name, address.municipality?.name, address.sector?.name]
      .filter(Boolean)
      .join(', '),
    line: [address.line1, address.line2].filter(Boolean).join(', '),
  }
}

const map = {
  toDireccionViewModel(model: Address): SiteApiSchema<'DireccionViewModel'> {
    return {
      sectorId: model.sector?.id,
      sector: model.sector?.name,
      municipioId: model.municipality?.id,
      municipio: model.municipality?.name,
      provinciaId: model.province?.id,
      provincia: model.province?.name,
      calle: model.line1,
      departamento: model.line2,
    }
  },
}

export const Address = {
  load,
  map,
  getFullAddress,
}
